import { useEditEntityDrawer, UseEditEntityDrawerReturnType } from '../UseEditEntityDrawer';
import { CalendarSlot } from './CalendarSlot';

export type SlotActionsMenuState = {
  isOpen: boolean;
  slot?: CalendarSlot;
  // Viewport coordinates the menu opens at.
  anchorPosition?: { top: number; left: number };
  // Areas view only: block the clicked area at the slot's time.
  areaBlock?: { areaLabel: string; open: () => void };
};

export const useSlotActionsMenu = (): UseEditEntityDrawerReturnType<SlotActionsMenuState> => {
  return useEditEntityDrawer<SlotActionsMenuState>({ isOpen: false });
};
